import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import ImportExport from '../../entities/importExport';
import AccountingConnection from '../../entities/accountingConnection';
import ActivityCategory from '../../entities/activityCategory';
import ActivityType from '../../entities/activityType';
import Address from '../../entities/address';
import Answer from '../../entities/answer';
import BankAccount from '../../entities/bankAccount';
import Blackout from '../../entities/blackout';
import Category from '../../entities/category';
import Campaign from '../../entities/campaign';
import Docket from '../../entities/docket';
import Matter from '../../entities/matter';
import Comment from '../../entities/comment';
import CaseType from '../../entities/caseType';
import CaseTypeStage from '../../entities/caseTypeStage';
import Deadline from '../../entities/deadline';
import DeadlineRule from '../../entities/deadlineRule';
import Conflict from '../../entities/conflict';
import Contact from '../../entities/contact';
import Court from '../../entities/court';
import CourtDeadlineRule from '../../entities/courtDeadlineRule';
import Discount from '../../entities/discount';
import EntityTimestamp from '../../entities/entityTimestamp';
import Document from '../../entities/document';
import Expense from '../../entities/expense';
import Event from '../../entities/event';
import Firm from '../../entities/firm';
import FlatFee from '../../entities/flatFee';
import FlatFeeMilestone from '../../entities/flatFeeMilestone';
import Group from '../../entities/group';
import HolidayCalendar from '../../entities/holidayCalendar';
import Identification from '../../entities/identification';
import ImportSource from '../../entities/importSource';
import Invoice from '../../entities/invoice';
import InvoiceBatch from '../../entities/invoiceBatch';
import InvoiceBatchItem from '../../entities/invoiceBatchItem';
import Lead from '../../entities/lead';
import Lookup from '../../entities/lookup';
import MatterStage from '../../entities/matterStage';
import Milestone from '../../entities/milestone';
import Option from '../../entities/option';
import Participant from '../../entities/participant';
import Privilege from '../../entities/privilege';
import Question from '../../entities/question';
import RedFlagType from '../../entities/redFlagType';
import RedFlag from '../../entities/redFlag';
import Resource from '../../entities/resource';
import Referral from '../../entities/referral';
import Role from '../../entities/role';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
import TimeOff from '../../entities/timeOff';
import Transaction from '../../entities/transaction';
import User from '../../entities/user';

/*
 * Delete/nullify anywhere this importExport is used in other entities
 *
 * @param {ImportExport} importExport
 */
export function deleteImportExport(importExport: ImportExport, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = importExport.id;
    }
    /* Simple delete usages */
        
    store.getState().accountingConnections
        .getMappingFor('importExportId', importExport.id)
        .filter(accountingConnectionTemp => accountingConnectionTemp.status !== 'D')
        .forEach(accountingConnectionTemp => {
            const _accountingConnection = accountingConnectionTemp.clone();
            _accountingConnection.status =  'U';
            _accountingConnection.addedOn = newHRTimestamp();
            _accountingConnection.addedBy = getCurrentUserId();
            _accountingConnection.importSource = targetImportSource;
            _accountingConnection.importId = mergeId;

            _accountingConnection.importId = null;
            store.dispatch(Actions.AccountingConnectionActions.saveAccountingConnectionQueue(_accountingConnection));
        });

    store.getState().activityCategories
        .getMappingFor('importExportId', importExport.id)
        .filter(activityCategoryTemp => activityCategoryTemp.status !== 'D')
        .forEach(activityCategoryTemp => {
            const _activityCategory = activityCategoryTemp.clone();
            _activityCategory.status =  'U';
            _activityCategory.addedOn = newHRTimestamp();
            _activityCategory.addedBy = getCurrentUserId();
            _activityCategory.importSource = targetImportSource;
            _activityCategory.importId = mergeId;

            _activityCategory.importId = null;
            store.dispatch(Actions.ActivityCategoryActions.saveActivityCategoryQueue(_activityCategory));
        });

    store.getState().activityTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(activityTypeTemp => activityTypeTemp.status !== 'D')
        .forEach(activityTypeTemp => {
            const _activityType = activityTypeTemp.clone();
            _activityType.status =  'U';
            _activityType.addedOn = newHRTimestamp();
            _activityType.addedBy = getCurrentUserId();
            _activityType.importSource = targetImportSource;
            _activityType.importId = mergeId;

            _activityType.importId = null;
            store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
        });

    store.getState().addresses
        .getMappingFor('importExportId', importExport.id)
        .filter(addressTemp => addressTemp.status !== 'D')
        .forEach(addressTemp => {
            const _address = addressTemp.clone();
            _address.status =  'U';
            _address.addedOn = newHRTimestamp();
            _address.addedBy = getCurrentUserId();
            _address.importSource = targetImportSource;
            _address.importId = mergeId;

            _address.importId = null;
            store.dispatch(Actions.AddressActions.saveAddressQueue(_address));
        });

    store.getState().answers
        .getMappingFor('importExportId', importExport.id)
        .filter(answerTemp => answerTemp.status !== 'D')
        .forEach(answerTemp => {
            const _answer = answerTemp.clone();
            _answer.status =  'U';
            _answer.addedOn = newHRTimestamp();
            _answer.addedBy = getCurrentUserId();
            _answer.importSource = targetImportSource;
            _answer.importId = mergeId;

            _answer.importId = null;
            store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
        });

    store.getState().bankAccounts
        .getMappingFor('importExportId', importExport.id)
        .filter(bankAccountTemp => bankAccountTemp.status !== 'D')
        .forEach(bankAccountTemp => {
            const _bankAccount = bankAccountTemp.clone();
            _bankAccount.status =  'U';
            _bankAccount.addedOn = newHRTimestamp();
            _bankAccount.addedBy = getCurrentUserId();
            _bankAccount.importSource = targetImportSource;
            _bankAccount.importId = mergeId;

            _bankAccount.importId = null;
            store.dispatch(Actions.BankAccountActions.saveBankAccountQueue(_bankAccount));
        });

    store.getState().blackouts
        .getMappingFor('importExportId', importExport.id)
        .filter(blackoutTemp => blackoutTemp.status !== 'D')
        .forEach(blackoutTemp => {
            const _blackout = blackoutTemp.clone();
            _blackout.status =  'U';
            _blackout.addedOn = newHRTimestamp();
            _blackout.addedBy = getCurrentUserId();
            _blackout.importSource = targetImportSource;
            _blackout.importId = mergeId;

            _blackout.importId = null;
            store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
        });

    store.getState().categories
        .getMappingFor('importExportId', importExport.id)
        .filter(categoryTemp => categoryTemp.status !== 'D')
        .forEach(categoryTemp => {
            const _category = categoryTemp.clone();
            _category.status =  'U';
            _category.addedOn = newHRTimestamp();
            _category.addedBy = getCurrentUserId();
            _category.importSource = targetImportSource;
            _category.importId = mergeId;

            _category.importId = null;
            store.dispatch(Actions.CategoryActions.saveCategoryQueue(_category));
        });

    store.getState().campaigns
        .getMappingFor('importExportId', importExport.id)
        .filter(campaignTemp => campaignTemp.status !== 'D')
        .forEach(campaignTemp => {
            const _campaign = campaignTemp.clone();
            _campaign.status =  'U';
            _campaign.addedOn = newHRTimestamp();
            _campaign.addedBy = getCurrentUserId();
            _campaign.importSource = targetImportSource;
            _campaign.importId = mergeId;

            _campaign.importId = null;
            store.dispatch(Actions.CampaignActions.saveCampaignQueue(_campaign));
        });

    store.getState().dockets
        .getMappingFor('importExportId', importExport.id)
        .filter(docketTemp => docketTemp.status !== 'D')
        .forEach(docketTemp => {
            const _docket = docketTemp.clone();
            _docket.status =  'U';
            _docket.addedOn = newHRTimestamp();
            _docket.addedBy = getCurrentUserId();
            _docket.importSource = targetImportSource;
            _docket.importId = mergeId;

            _docket.importId = null;
            store.dispatch(Actions.DocketActions.saveDocketQueue(_docket));
        });

    store.getState().matters
        .getMappingFor('importExportId', importExport.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.importId = null;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().comments
        .getMappingFor('importExportId', importExport.id)
        .filter(commentTemp => commentTemp.status !== 'D')
        .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            _comment.status =  'U';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;

            _comment.importId = null;
            store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
        });

    store.getState().caseTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(caseTypeTemp => caseTypeTemp.status !== 'D')
        .forEach(caseTypeTemp => {
            const _caseType = caseTypeTemp.clone();
            _caseType.status =  'U';
            _caseType.addedOn = newHRTimestamp();
            _caseType.addedBy = getCurrentUserId();
            _caseType.importSource = targetImportSource;
            _caseType.importId = mergeId;

            _caseType.importId = null;
            store.dispatch(Actions.CaseTypeActions.saveCaseTypeQueue(_caseType));
        });

    store.getState().caseTypeStages
        .getMappingFor('importExportId', importExport.id)
        .filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D')
        .forEach(caseTypeStageTemp => {
            const _caseTypeStage = caseTypeStageTemp.clone();
            _caseTypeStage.status =  'U';
            _caseTypeStage.addedOn = newHRTimestamp();
            _caseTypeStage.addedBy = getCurrentUserId();
            _caseTypeStage.importSource = targetImportSource;
            _caseTypeStage.importId = mergeId;

            _caseTypeStage.importId = null;
            store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
        });

    store.getState().deadlines
        .getMappingFor('importExportId', importExport.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.importId = null;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    store.getState().deadlineRules
        .getMappingFor('importExportId', importExport.id)
        .filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D')
        .forEach(deadlineRuleTemp => {
            const _deadlineRule = deadlineRuleTemp.clone();
            _deadlineRule.status =  'U';
            _deadlineRule.addedOn = newHRTimestamp();
            _deadlineRule.addedBy = getCurrentUserId();
            _deadlineRule.importSource = targetImportSource;
            _deadlineRule.importId = mergeId;

            _deadlineRule.importId = null;
            store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
        });

    store.getState().conflicts
        .getMappingFor('importExportId', importExport.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.addedBy = getCurrentUserId();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.importId = null;
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().contacts
        .getMappingFor('importExportId', importExport.id)
        .filter(contactTemp => contactTemp.status !== 'D')
        .forEach(contactTemp => {
            const _contact = contactTemp.clone();
            _contact.status =  'U';
            _contact.addedOn = newHRTimestamp();
            _contact.addedBy = getCurrentUserId();
            _contact.importSource = targetImportSource;
            _contact.importId = mergeId;

            _contact.importId = null;
            store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
        });

    store.getState().courts
        .getMappingFor('importExportId', importExport.id)
        .filter(courtTemp => courtTemp.status !== 'D')
        .forEach(courtTemp => {
            const _court = courtTemp.clone();
            _court.status =  'U';
            _court.addedOn = newHRTimestamp();
            _court.addedBy = getCurrentUserId();
            _court.importSource = targetImportSource;
            _court.importId = mergeId;

            _court.importId = null;
            store.dispatch(Actions.CourtActions.saveCourtQueue(_court));
        });

    store.getState().courtDeadlineRules
        .getMappingFor('importExportId', importExport.id)
        .filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D')
        .forEach(courtDeadlineRuleTemp => {
            const _courtDeadlineRule = courtDeadlineRuleTemp.clone();
            _courtDeadlineRule.status =  'U';
            _courtDeadlineRule.addedOn = newHRTimestamp();
            _courtDeadlineRule.addedBy = getCurrentUserId();
            _courtDeadlineRule.importSource = targetImportSource;
            _courtDeadlineRule.importId = mergeId;

            _courtDeadlineRule.importId = null;
            store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
        });

    store.getState().discounts
        .getMappingFor('importExportId', importExport.id)
        .filter(discountTemp => discountTemp.status !== 'D')
        .forEach(discountTemp => {
            const _discount = discountTemp.clone();
            _discount.status =  'U';
            _discount.addedOn = newHRTimestamp();
            _discount.addedBy = getCurrentUserId();
            _discount.importSource = targetImportSource;
            _discount.importId = mergeId;

            _discount.importId = null;
            store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
        });

    store.getState().entityTimestamps
        .getMappingFor('importExportId', importExport.id)
        .filter(entityTimestampTemp => entityTimestampTemp.status !== 'D')
        .forEach(entityTimestampTemp => {
            const _entityTimestamp = entityTimestampTemp.clone();
            _entityTimestamp.status =  'U';
            _entityTimestamp.addedOn = newHRTimestamp();
            _entityTimestamp.addedBy = getCurrentUserId();
            _entityTimestamp.importSource = targetImportSource;
            _entityTimestamp.importId = mergeId;

            _entityTimestamp.importId = null;
            store.dispatch(Actions.EntityTimestampActions.saveEntityTimestampQueue(_entityTimestamp));
        });

    store.getState().documents
        .getMappingFor('importExportId', importExport.id)
        .filter(documentTemp => documentTemp.status !== 'D')
        .forEach(documentTemp => {
            const _document = documentTemp.clone();
            _document.status =  'U';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;

            _document.importId = null;
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
        });

    store.getState().expenses
        .getMappingFor('importExportId', importExport.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.importId = null;
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().events
        .getMappingFor('importExportId', importExport.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.importId = null;
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    store.getState().firms
        .getMappingFor('importExportId', importExport.id)
        .filter(firmTemp => firmTemp.status !== 'D')
        .forEach(firmTemp => {
            const _firm = firmTemp.clone();
            _firm.status =  'U';
            _firm.addedOn = newHRTimestamp();
            _firm.addedBy = getCurrentUserId();
            _firm.importSource = targetImportSource;
            _firm.importId = mergeId;

            _firm.importId = null;
            store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
        });

    store.getState().flatFees
        .getMappingFor('importExportId', importExport.id)
        .filter(flatFeeTemp => flatFeeTemp.status !== 'D')
        .forEach(flatFeeTemp => {
            const _flatFee = flatFeeTemp.clone();
            _flatFee.status =  'U';
            _flatFee.addedOn = newHRTimestamp();
            _flatFee.addedBy = getCurrentUserId();
            _flatFee.importSource = targetImportSource;
            _flatFee.importId = mergeId;

            _flatFee.importId = null;
            store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
        });

    store.getState().flatFeeMilestones
        .getMappingFor('importExportId', importExport.id)
        .filter(flatFeeMilestoneTemp => flatFeeMilestoneTemp.status !== 'D')
        .forEach(flatFeeMilestoneTemp => {
            const _flatFeeMilestone = flatFeeMilestoneTemp.clone();
            _flatFeeMilestone.status =  'U';
            _flatFeeMilestone.addedOn = newHRTimestamp();
            _flatFeeMilestone.addedBy = getCurrentUserId();
            _flatFeeMilestone.importSource = targetImportSource;
            _flatFeeMilestone.importId = mergeId;

            _flatFeeMilestone.importId = null;
            store.dispatch(Actions.FlatFeeMilestoneActions.saveFlatFeeMilestoneQueue(_flatFeeMilestone));
        });

    store.getState().groups
        .getMappingFor('importExportId', importExport.id)
        .filter(groupTemp => groupTemp.status !== 'D')
        .forEach(groupTemp => {
            const _group = groupTemp.clone();
            _group.status =  'U';
            _group.addedOn = newHRTimestamp();
            _group.addedBy = getCurrentUserId();
            _group.importSource = targetImportSource;
            _group.importId = mergeId;

            _group.importId = null;
            store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
        });

    store.getState().holidayCalendars
        .getMappingFor('importExportId', importExport.id)
        .filter(holidayCalendarTemp => holidayCalendarTemp.status !== 'D')
        .forEach(holidayCalendarTemp => {
            const _holidayCalendar = holidayCalendarTemp.clone();
            _holidayCalendar.status =  'U';
            _holidayCalendar.addedOn = newHRTimestamp();
            _holidayCalendar.addedBy = getCurrentUserId();
            _holidayCalendar.importSource = targetImportSource;
            _holidayCalendar.importId = mergeId;

            _holidayCalendar.importId = null;
            store.dispatch(Actions.HolidayCalendarActions.saveHolidayCalendarQueue(_holidayCalendar));
        });

    store.getState().identifications
        .getMappingFor('importExportId', importExport.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.importId = null;
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    store.getState().importExports
        .getMappingFor('importExportId', importExport.id)
        .filter(importExportTemp => importExportTemp.status !== 'D')
        .forEach(importExportTemp => {
            const _importExport = importExportTemp.clone();
            _importExport.status =  'U';
            _importExport.addedOn = newHRTimestamp();
            _importExport.addedBy = getCurrentUserId();
            _importExport.importSource = targetImportSource;
            _importExport.importId = mergeId;

            _importExport.importId = null;
            store.dispatch(Actions.ImportExportActions.saveImportExportQueue(_importExport));
        });

    store.getState().importSources
        .getMappingFor('importExportId', importExport.id)
        .filter(importSourceTemp => importSourceTemp.status !== 'D')
        .forEach(importSourceTemp => {
            const _importSource = importSourceTemp.clone();
            _importSource.status =  'U';
            _importSource.addedOn = newHRTimestamp();
            _importSource.addedBy = getCurrentUserId();
            _importSource.importSource = targetImportSource;
            _importSource.importId = mergeId;

            _importSource.importId = null;
            store.dispatch(Actions.ImportSourceActions.saveImportSourceQueue(_importSource));
        });

    store.getState().invoices
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.addedBy = getCurrentUserId();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.importId = null;
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().invoiceBatches
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D')
        .forEach(invoiceBatchTemp => {
            const _invoiceBatch = invoiceBatchTemp.clone();
            _invoiceBatch.status =  'U';
            _invoiceBatch.addedOn = newHRTimestamp();
            _invoiceBatch.addedBy = getCurrentUserId();
            _invoiceBatch.importSource = targetImportSource;
            _invoiceBatch.importId = mergeId;

            _invoiceBatch.importId = null;
            store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
        });

    store.getState().invoiceBatchItems
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceBatchItemTemp => invoiceBatchItemTemp.status !== 'D')
        .forEach(invoiceBatchItemTemp => {
            const _invoiceBatchItem = invoiceBatchItemTemp.clone();
            _invoiceBatchItem.status =  'U';
            _invoiceBatchItem.addedOn = newHRTimestamp();
            _invoiceBatchItem.addedBy = getCurrentUserId();
            _invoiceBatchItem.importSource = targetImportSource;
            _invoiceBatchItem.importId = mergeId;

            _invoiceBatchItem.importId = null;
            store.dispatch(Actions.InvoiceBatchItemActions.saveInvoiceBatchItemQueue(_invoiceBatchItem));
        });

    store.getState().leads
        .getMappingFor('importExportId', importExport.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.addedBy = getCurrentUserId();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.importId = null;
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().lookups
        .getMappingFor('importExportId', importExport.id)
        .filter(lookupTemp => lookupTemp.status !== 'D')
        .forEach(lookupTemp => {
            const _lookup = lookupTemp.clone();
            _lookup.status =  'U';
            _lookup.addedOn = newHRTimestamp();
            _lookup.addedBy = getCurrentUserId();
            _lookup.importSource = targetImportSource;
            _lookup.importId = mergeId;

            _lookup.importId = null;
            store.dispatch(Actions.LookupActions.saveLookupQueue(_lookup));
        });

    store.getState().matterStages
        .getMappingFor('importExportId', importExport.id)
        .filter(matterStageTemp => matterStageTemp.status !== 'D')
        .forEach(matterStageTemp => {
            const _matterStage = matterStageTemp.clone();
            _matterStage.status =  'U';
            _matterStage.addedOn = newHRTimestamp();
            _matterStage.addedBy = getCurrentUserId();
            _matterStage.importSource = targetImportSource;
            _matterStage.importId = mergeId;

            _matterStage.importId = null;
            store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
        });

    store.getState().milestones
        .getMappingFor('importExportId', importExport.id)
        .filter(milestoneTemp => milestoneTemp.status !== 'D')
        .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            _milestone.status =  'U';
            _milestone.addedOn = newHRTimestamp();
            _milestone.addedBy = getCurrentUserId();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;

            _milestone.importId = null;
            store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
        });

    store.getState().options
        .getMappingFor('importExportId', importExport.id)
        .filter(optionTemp => optionTemp.status !== 'D')
        .forEach(optionTemp => {
            const _option = optionTemp.clone();
            _option.status =  'U';
            _option.addedOn = newHRTimestamp();
            _option.addedBy = getCurrentUserId();
            _option.importSource = targetImportSource;
            _option.importId = mergeId;

            _option.importId = null;
            store.dispatch(Actions.OptionActions.saveOptionQueue(_option));
        });

    store.getState().participants
        .getMappingFor('importExportId', importExport.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.importId = null;
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().privileges
        .getMappingFor('importExportId', importExport.id)
        .filter(privilegeTemp => privilegeTemp.status !== 'D')
        .forEach(privilegeTemp => {
            const _privilege = privilegeTemp.clone();
            _privilege.status =  'U';
            _privilege.addedOn = newHRTimestamp();
            _privilege.addedBy = getCurrentUserId();
            _privilege.importSource = targetImportSource;
            _privilege.importId = mergeId;

            _privilege.importId = null;
            store.dispatch(Actions.PrivilegeActions.savePrivilegeQueue(_privilege));
        });

    store.getState().questions
        .getMappingFor('importExportId', importExport.id)
        .filter(questionTemp => questionTemp.status !== 'D')
        .forEach(questionTemp => {
            const _question = questionTemp.clone();
            _question.status =  'U';
            _question.addedOn = newHRTimestamp();
            _question.addedBy = getCurrentUserId();
            _question.importSource = targetImportSource;
            _question.importId = mergeId;

            _question.importId = null;
            store.dispatch(Actions.QuestionActions.saveQuestionQueue(_question));
        });

    store.getState().redFlagTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(redFlagTypeTemp => redFlagTypeTemp.status !== 'D')
        .forEach(redFlagTypeTemp => {
            const _redFlagType = redFlagTypeTemp.clone();
            _redFlagType.status =  'U';
            _redFlagType.addedOn = newHRTimestamp();
            _redFlagType.addedBy = getCurrentUserId();
            _redFlagType.importSource = targetImportSource;
            _redFlagType.importId = mergeId;

            _redFlagType.importId = null;
            store.dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType));
        });

    store.getState().redFlags
        .getMappingFor('importExportId', importExport.id)
        .filter(redFlagTemp => redFlagTemp.status !== 'D')
        .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            _redFlag.status =  'U';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;

            _redFlag.importId = null;
            store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
        });

    store.getState().resources
        .getMappingFor('importExportId', importExport.id)
        .filter(resourceTemp => resourceTemp.status !== 'D')
        .forEach(resourceTemp => {
            const _resource = resourceTemp.clone();
            _resource.status =  'U';
            _resource.addedOn = newHRTimestamp();
            _resource.addedBy = getCurrentUserId();
            _resource.importSource = targetImportSource;
            _resource.importId = mergeId;

            _resource.importId = null;
            store.dispatch(Actions.ResourceActions.saveResourceQueue(_resource));
        });

    store.getState().referrals
        .getMappingFor('importExportId', importExport.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.importId = null;
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    store.getState().roles
        .getMappingFor('importExportId', importExport.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.addedBy = getCurrentUserId();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.importId = null;
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    store.getState().tasks
        .getMappingFor('importExportId', importExport.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.importId = null;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('importExportId', importExport.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.addedBy = getCurrentUserId();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.importId = null;
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    store.getState().timeOffs
        .getMappingFor('importExportId', importExport.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.importId = null;
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    store.getState().transactions
        .getMappingFor('importExportId', importExport.id)
        .filter(transactionTemp => transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            _transaction.status =  'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;

            _transaction.importId = null;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    store.getState().users
        .getMappingFor('importExportId', importExport.id)
        .filter(userTemp => userTemp.status !== 'D')
        .forEach(userTemp => {
            const _user = userTemp.clone();
            _user.status =  'U';
            _user.addedOn = newHRTimestamp();
            _user.addedBy = getCurrentUserId();
            _user.importSource = targetImportSource;
            _user.importId = mergeId;

            _user.importId = null;
            store.dispatch(Actions.UserActions.saveUserQueue(_user));
        });

    /* Remove the actual importExport */
    importExport.status = 'D';
    importExport.addedOn = newHRTimestamp();
    importExport.addedBy = getCurrentUserId();
    importExport.importSource = targetImportSource;
    importExport.importId = mergeId;
    store.dispatch(Actions.ImportExportActions.removeImportExportQueue(importExport));
    
}

/*
 * Replace anywhere this importExport is used in other entities.
 *
 * @param {ImportExport} importExport
 * @param {ImportExport} replaceWith
 * @return {ImportExport} - ImportExport will have refs stripped away
 */
export function replaceImportExport(importExport: ImportExport, replaceWith: ImportExport, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = importExport.id;
    }
    /* Simple replace usages */
        
    store.getState().accountingConnections
        .getMappingFor('importExportId', importExport.id)
        .filter(accountingConnectionTemp => accountingConnectionTemp.status !== 'D')
        .forEach(accountingConnectionTemp => {
            const _accountingConnection = accountingConnectionTemp.clone();
            _accountingConnection.status =  'U';
            _accountingConnection.addedOn = newHRTimestamp();
            _accountingConnection.addedBy = getCurrentUserId();
            _accountingConnection.importSource = targetImportSource;
            _accountingConnection.importId = mergeId;

            _accountingConnection.importId = replaceWith.id;
            store.dispatch(Actions.AccountingConnectionActions.saveAccountingConnectionQueue(_accountingConnection));
        });

    store.getState().activityCategories
        .getMappingFor('importExportId', importExport.id)
        .filter(activityCategoryTemp => activityCategoryTemp.status !== 'D')
        .forEach(activityCategoryTemp => {
            const _activityCategory = activityCategoryTemp.clone();
            _activityCategory.status =  'U';
            _activityCategory.addedOn = newHRTimestamp();
            _activityCategory.addedBy = getCurrentUserId();
            _activityCategory.importSource = targetImportSource;
            _activityCategory.importId = mergeId;

            _activityCategory.importId = replaceWith.id;
            store.dispatch(Actions.ActivityCategoryActions.saveActivityCategoryQueue(_activityCategory));
        });

    store.getState().activityTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(activityTypeTemp => activityTypeTemp.status !== 'D')
        .forEach(activityTypeTemp => {
            const _activityType = activityTypeTemp.clone();
            _activityType.status =  'U';
            _activityType.addedOn = newHRTimestamp();
            _activityType.addedBy = getCurrentUserId();
            _activityType.importSource = targetImportSource;
            _activityType.importId = mergeId;

            _activityType.importId = replaceWith.id;
            store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
        });

    store.getState().addresses
        .getMappingFor('importExportId', importExport.id)
        .filter(addressTemp => addressTemp.status !== 'D')
        .forEach(addressTemp => {
            const _address = addressTemp.clone();
            _address.status =  'U';
            _address.addedOn = newHRTimestamp();
            _address.addedBy = getCurrentUserId();
            _address.importSource = targetImportSource;
            _address.importId = mergeId;

            _address.importId = replaceWith.id;
            store.dispatch(Actions.AddressActions.saveAddressQueue(_address));
        });

    store.getState().answers
        .getMappingFor('importExportId', importExport.id)
        .filter(answerTemp => answerTemp.status !== 'D')
        .forEach(answerTemp => {
            const _answer = answerTemp.clone();
            _answer.status =  'U';
            _answer.addedOn = newHRTimestamp();
            _answer.addedBy = getCurrentUserId();
            _answer.importSource = targetImportSource;
            _answer.importId = mergeId;

            _answer.importId = replaceWith.id;
            store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
        });

    store.getState().bankAccounts
        .getMappingFor('importExportId', importExport.id)
        .filter(bankAccountTemp => bankAccountTemp.status !== 'D')
        .forEach(bankAccountTemp => {
            const _bankAccount = bankAccountTemp.clone();
            _bankAccount.status =  'U';
            _bankAccount.addedOn = newHRTimestamp();
            _bankAccount.addedBy = getCurrentUserId();
            _bankAccount.importSource = targetImportSource;
            _bankAccount.importId = mergeId;

            _bankAccount.importId = replaceWith.id;
            store.dispatch(Actions.BankAccountActions.saveBankAccountQueue(_bankAccount));
        });

    store.getState().blackouts
        .getMappingFor('importExportId', importExport.id)
        .filter(blackoutTemp => blackoutTemp.status !== 'D')
        .forEach(blackoutTemp => {
            const _blackout = blackoutTemp.clone();
            _blackout.status =  'U';
            _blackout.addedOn = newHRTimestamp();
            _blackout.addedBy = getCurrentUserId();
            _blackout.importSource = targetImportSource;
            _blackout.importId = mergeId;

            _blackout.importId = replaceWith.id;
            store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
        });

    store.getState().categories
        .getMappingFor('importExportId', importExport.id)
        .filter(categoryTemp => categoryTemp.status !== 'D')
        .forEach(categoryTemp => {
            const _category = categoryTemp.clone();
            _category.status =  'U';
            _category.addedOn = newHRTimestamp();
            _category.addedBy = getCurrentUserId();
            _category.importSource = targetImportSource;
            _category.importId = mergeId;

            _category.importId = replaceWith.id;
            store.dispatch(Actions.CategoryActions.saveCategoryQueue(_category));
        });

    store.getState().campaigns
        .getMappingFor('importExportId', importExport.id)
        .filter(campaignTemp => campaignTemp.status !== 'D')
        .forEach(campaignTemp => {
            const _campaign = campaignTemp.clone();
            _campaign.status =  'U';
            _campaign.addedOn = newHRTimestamp();
            _campaign.addedBy = getCurrentUserId();
            _campaign.importSource = targetImportSource;
            _campaign.importId = mergeId;

            _campaign.importId = replaceWith.id;
            store.dispatch(Actions.CampaignActions.saveCampaignQueue(_campaign));
        });

    store.getState().dockets
        .getMappingFor('importExportId', importExport.id)
        .filter(docketTemp => docketTemp.status !== 'D')
        .forEach(docketTemp => {
            const _docket = docketTemp.clone();
            _docket.status =  'U';
            _docket.addedOn = newHRTimestamp();
            _docket.addedBy = getCurrentUserId();
            _docket.importSource = targetImportSource;
            _docket.importId = mergeId;

            _docket.importId = replaceWith.id;
            store.dispatch(Actions.DocketActions.saveDocketQueue(_docket));
        });

    store.getState().matters
        .getMappingFor('importExportId', importExport.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.importId = replaceWith.id;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().comments
        .getMappingFor('importExportId', importExport.id)
        .filter(commentTemp => commentTemp.status !== 'D')
        .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            _comment.status =  'U';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;

            _comment.importId = replaceWith.id;
            store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
        });

    store.getState().caseTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(caseTypeTemp => caseTypeTemp.status !== 'D')
        .forEach(caseTypeTemp => {
            const _caseType = caseTypeTemp.clone();
            _caseType.status =  'U';
            _caseType.addedOn = newHRTimestamp();
            _caseType.addedBy = getCurrentUserId();
            _caseType.importSource = targetImportSource;
            _caseType.importId = mergeId;

            _caseType.importId = replaceWith.id;
            store.dispatch(Actions.CaseTypeActions.saveCaseTypeQueue(_caseType));
        });

    store.getState().caseTypeStages
        .getMappingFor('importExportId', importExport.id)
        .filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D')
        .forEach(caseTypeStageTemp => {
            const _caseTypeStage = caseTypeStageTemp.clone();
            _caseTypeStage.status =  'U';
            _caseTypeStage.addedOn = newHRTimestamp();
            _caseTypeStage.addedBy = getCurrentUserId();
            _caseTypeStage.importSource = targetImportSource;
            _caseTypeStage.importId = mergeId;

            _caseTypeStage.importId = replaceWith.id;
            store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
        });

    store.getState().deadlines
        .getMappingFor('importExportId', importExport.id)
        .filter(deadlineTemp => deadlineTemp.status !== 'D')
        .forEach(deadlineTemp => {
            const _deadline = deadlineTemp.clone();
            _deadline.status =  'U';
            _deadline.addedOn = newHRTimestamp();
            _deadline.addedBy = getCurrentUserId();
            _deadline.importSource = targetImportSource;
            _deadline.importId = mergeId;

            _deadline.importId = replaceWith.id;
            store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
        });

    store.getState().deadlineRules
        .getMappingFor('importExportId', importExport.id)
        .filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D')
        .forEach(deadlineRuleTemp => {
            const _deadlineRule = deadlineRuleTemp.clone();
            _deadlineRule.status =  'U';
            _deadlineRule.addedOn = newHRTimestamp();
            _deadlineRule.addedBy = getCurrentUserId();
            _deadlineRule.importSource = targetImportSource;
            _deadlineRule.importId = mergeId;

            _deadlineRule.importId = replaceWith.id;
            store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
        });

    store.getState().conflicts
        .getMappingFor('importExportId', importExport.id)
        .filter(conflictTemp => conflictTemp.status !== 'D')
        .forEach(conflictTemp => {
            const _conflict = conflictTemp.clone();
            _conflict.status =  'U';
            _conflict.addedOn = newHRTimestamp();
            _conflict.addedBy = getCurrentUserId();
            _conflict.importSource = targetImportSource;
            _conflict.importId = mergeId;

            _conflict.importId = replaceWith.id;
            store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
        });

    store.getState().contacts
        .getMappingFor('importExportId', importExport.id)
        .filter(contactTemp => contactTemp.status !== 'D')
        .forEach(contactTemp => {
            const _contact = contactTemp.clone();
            _contact.status =  'U';
            _contact.addedOn = newHRTimestamp();
            _contact.addedBy = getCurrentUserId();
            _contact.importSource = targetImportSource;
            _contact.importId = mergeId;

            _contact.importId = replaceWith.id;
            store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
        });

    store.getState().courts
        .getMappingFor('importExportId', importExport.id)
        .filter(courtTemp => courtTemp.status !== 'D')
        .forEach(courtTemp => {
            const _court = courtTemp.clone();
            _court.status =  'U';
            _court.addedOn = newHRTimestamp();
            _court.addedBy = getCurrentUserId();
            _court.importSource = targetImportSource;
            _court.importId = mergeId;

            _court.importId = replaceWith.id;
            store.dispatch(Actions.CourtActions.saveCourtQueue(_court));
        });

    store.getState().courtDeadlineRules
        .getMappingFor('importExportId', importExport.id)
        .filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D')
        .forEach(courtDeadlineRuleTemp => {
            const _courtDeadlineRule = courtDeadlineRuleTemp.clone();
            _courtDeadlineRule.status =  'U';
            _courtDeadlineRule.addedOn = newHRTimestamp();
            _courtDeadlineRule.addedBy = getCurrentUserId();
            _courtDeadlineRule.importSource = targetImportSource;
            _courtDeadlineRule.importId = mergeId;

            _courtDeadlineRule.importId = replaceWith.id;
            store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
        });

    store.getState().discounts
        .getMappingFor('importExportId', importExport.id)
        .filter(discountTemp => discountTemp.status !== 'D')
        .forEach(discountTemp => {
            const _discount = discountTemp.clone();
            _discount.status =  'U';
            _discount.addedOn = newHRTimestamp();
            _discount.addedBy = getCurrentUserId();
            _discount.importSource = targetImportSource;
            _discount.importId = mergeId;

            _discount.importId = replaceWith.id;
            store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
        });

    store.getState().entityTimestamps
        .getMappingFor('importExportId', importExport.id)
        .filter(entityTimestampTemp => entityTimestampTemp.status !== 'D')
        .forEach(entityTimestampTemp => {
            const _entityTimestamp = entityTimestampTemp.clone();
            _entityTimestamp.status =  'U';
            _entityTimestamp.addedOn = newHRTimestamp();
            _entityTimestamp.addedBy = getCurrentUserId();
            _entityTimestamp.importSource = targetImportSource;
            _entityTimestamp.importId = mergeId;

            _entityTimestamp.importId = replaceWith.id;
            store.dispatch(Actions.EntityTimestampActions.saveEntityTimestampQueue(_entityTimestamp));
        });

    store.getState().documents
        .getMappingFor('importExportId', importExport.id)
        .filter(documentTemp => documentTemp.status !== 'D')
        .forEach(documentTemp => {
            const _document = documentTemp.clone();
            _document.status =  'U';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;

            _document.importId = replaceWith.id;
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
        });

    store.getState().expenses
        .getMappingFor('importExportId', importExport.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.importId = replaceWith.id;
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().events
        .getMappingFor('importExportId', importExport.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.importId = replaceWith.id;
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    store.getState().firms
        .getMappingFor('importExportId', importExport.id)
        .filter(firmTemp => firmTemp.status !== 'D')
        .forEach(firmTemp => {
            const _firm = firmTemp.clone();
            _firm.status =  'U';
            _firm.addedOn = newHRTimestamp();
            _firm.addedBy = getCurrentUserId();
            _firm.importSource = targetImportSource;
            _firm.importId = mergeId;

            _firm.importId = replaceWith.id;
            store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
        });

    store.getState().flatFees
        .getMappingFor('importExportId', importExport.id)
        .filter(flatFeeTemp => flatFeeTemp.status !== 'D')
        .forEach(flatFeeTemp => {
            const _flatFee = flatFeeTemp.clone();
            _flatFee.status =  'U';
            _flatFee.addedOn = newHRTimestamp();
            _flatFee.addedBy = getCurrentUserId();
            _flatFee.importSource = targetImportSource;
            _flatFee.importId = mergeId;

            _flatFee.importId = replaceWith.id;
            store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
        });

    store.getState().flatFeeMilestones
        .getMappingFor('importExportId', importExport.id)
        .filter(flatFeeMilestoneTemp => flatFeeMilestoneTemp.status !== 'D')
        .forEach(flatFeeMilestoneTemp => {
            const _flatFeeMilestone = flatFeeMilestoneTemp.clone();
            _flatFeeMilestone.status =  'U';
            _flatFeeMilestone.addedOn = newHRTimestamp();
            _flatFeeMilestone.addedBy = getCurrentUserId();
            _flatFeeMilestone.importSource = targetImportSource;
            _flatFeeMilestone.importId = mergeId;

            _flatFeeMilestone.importId = replaceWith.id;
            store.dispatch(Actions.FlatFeeMilestoneActions.saveFlatFeeMilestoneQueue(_flatFeeMilestone));
        });

    store.getState().groups
        .getMappingFor('importExportId', importExport.id)
        .filter(groupTemp => groupTemp.status !== 'D')
        .forEach(groupTemp => {
            const _group = groupTemp.clone();
            _group.status =  'U';
            _group.addedOn = newHRTimestamp();
            _group.addedBy = getCurrentUserId();
            _group.importSource = targetImportSource;
            _group.importId = mergeId;

            _group.importId = replaceWith.id;
            store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
        });

    store.getState().holidayCalendars
        .getMappingFor('importExportId', importExport.id)
        .filter(holidayCalendarTemp => holidayCalendarTemp.status !== 'D')
        .forEach(holidayCalendarTemp => {
            const _holidayCalendar = holidayCalendarTemp.clone();
            _holidayCalendar.status =  'U';
            _holidayCalendar.addedOn = newHRTimestamp();
            _holidayCalendar.addedBy = getCurrentUserId();
            _holidayCalendar.importSource = targetImportSource;
            _holidayCalendar.importId = mergeId;

            _holidayCalendar.importId = replaceWith.id;
            store.dispatch(Actions.HolidayCalendarActions.saveHolidayCalendarQueue(_holidayCalendar));
        });

    store.getState().identifications
        .getMappingFor('importExportId', importExport.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.importId = replaceWith.id;
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    store.getState().importExports
        .getMappingFor('importExportId', importExport.id)
        .filter(importExportTemp => importExportTemp.status !== 'D')
        .forEach(importExportTemp => {
            const _importExport = importExportTemp.clone();
            _importExport.status =  'U';
            _importExport.addedOn = newHRTimestamp();
            _importExport.addedBy = getCurrentUserId();
            _importExport.importSource = targetImportSource;
            _importExport.importId = mergeId;

            _importExport.importId = replaceWith.id;
            store.dispatch(Actions.ImportExportActions.saveImportExportQueue(_importExport));
        });

    store.getState().importSources
        .getMappingFor('importExportId', importExport.id)
        .filter(importSourceTemp => importSourceTemp.status !== 'D')
        .forEach(importSourceTemp => {
            const _importSource = importSourceTemp.clone();
            _importSource.status =  'U';
            _importSource.addedOn = newHRTimestamp();
            _importSource.addedBy = getCurrentUserId();
            _importSource.importSource = targetImportSource;
            _importSource.importId = mergeId;

            _importSource.importId = replaceWith.id;
            store.dispatch(Actions.ImportSourceActions.saveImportSourceQueue(_importSource));
        });

    store.getState().invoices
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.addedBy = getCurrentUserId();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.importId = replaceWith.id;
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().invoiceBatches
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D')
        .forEach(invoiceBatchTemp => {
            const _invoiceBatch = invoiceBatchTemp.clone();
            _invoiceBatch.status =  'U';
            _invoiceBatch.addedOn = newHRTimestamp();
            _invoiceBatch.addedBy = getCurrentUserId();
            _invoiceBatch.importSource = targetImportSource;
            _invoiceBatch.importId = mergeId;

            _invoiceBatch.importId = replaceWith.id;
            store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
        });

    store.getState().invoiceBatchItems
        .getMappingFor('importExportId', importExport.id)
        .filter(invoiceBatchItemTemp => invoiceBatchItemTemp.status !== 'D')
        .forEach(invoiceBatchItemTemp => {
            const _invoiceBatchItem = invoiceBatchItemTemp.clone();
            _invoiceBatchItem.status =  'U';
            _invoiceBatchItem.addedOn = newHRTimestamp();
            _invoiceBatchItem.addedBy = getCurrentUserId();
            _invoiceBatchItem.importSource = targetImportSource;
            _invoiceBatchItem.importId = mergeId;

            _invoiceBatchItem.importId = replaceWith.id;
            store.dispatch(Actions.InvoiceBatchItemActions.saveInvoiceBatchItemQueue(_invoiceBatchItem));
        });

    store.getState().leads
        .getMappingFor('importExportId', importExport.id)
        .filter(leadTemp => leadTemp.status !== 'D')
        .forEach(leadTemp => {
            const _lead = leadTemp.clone();
            _lead.status =  'U';
            _lead.addedOn = newHRTimestamp();
            _lead.addedBy = getCurrentUserId();
            _lead.importSource = targetImportSource;
            _lead.importId = mergeId;

            _lead.importId = replaceWith.id;
            store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
        });

    store.getState().lookups
        .getMappingFor('importExportId', importExport.id)
        .filter(lookupTemp => lookupTemp.status !== 'D')
        .forEach(lookupTemp => {
            const _lookup = lookupTemp.clone();
            _lookup.status =  'U';
            _lookup.addedOn = newHRTimestamp();
            _lookup.addedBy = getCurrentUserId();
            _lookup.importSource = targetImportSource;
            _lookup.importId = mergeId;

            _lookup.importId = replaceWith.id;
            store.dispatch(Actions.LookupActions.saveLookupQueue(_lookup));
        });

    store.getState().matterStages
        .getMappingFor('importExportId', importExport.id)
        .filter(matterStageTemp => matterStageTemp.status !== 'D')
        .forEach(matterStageTemp => {
            const _matterStage = matterStageTemp.clone();
            _matterStage.status =  'U';
            _matterStage.addedOn = newHRTimestamp();
            _matterStage.addedBy = getCurrentUserId();
            _matterStage.importSource = targetImportSource;
            _matterStage.importId = mergeId;

            _matterStage.importId = replaceWith.id;
            store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
        });

    store.getState().milestones
        .getMappingFor('importExportId', importExport.id)
        .filter(milestoneTemp => milestoneTemp.status !== 'D')
        .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            _milestone.status =  'U';
            _milestone.addedOn = newHRTimestamp();
            _milestone.addedBy = getCurrentUserId();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;

            _milestone.importId = replaceWith.id;
            store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
        });

    store.getState().options
        .getMappingFor('importExportId', importExport.id)
        .filter(optionTemp => optionTemp.status !== 'D')
        .forEach(optionTemp => {
            const _option = optionTemp.clone();
            _option.status =  'U';
            _option.addedOn = newHRTimestamp();
            _option.addedBy = getCurrentUserId();
            _option.importSource = targetImportSource;
            _option.importId = mergeId;

            _option.importId = replaceWith.id;
            store.dispatch(Actions.OptionActions.saveOptionQueue(_option));
        });

    store.getState().participants
        .getMappingFor('importExportId', importExport.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.importId = replaceWith.id;
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().privileges
        .getMappingFor('importExportId', importExport.id)
        .filter(privilegeTemp => privilegeTemp.status !== 'D')
        .forEach(privilegeTemp => {
            const _privilege = privilegeTemp.clone();
            _privilege.status =  'U';
            _privilege.addedOn = newHRTimestamp();
            _privilege.addedBy = getCurrentUserId();
            _privilege.importSource = targetImportSource;
            _privilege.importId = mergeId;

            _privilege.importId = replaceWith.id;
            store.dispatch(Actions.PrivilegeActions.savePrivilegeQueue(_privilege));
        });

    store.getState().questions
        .getMappingFor('importExportId', importExport.id)
        .filter(questionTemp => questionTemp.status !== 'D')
        .forEach(questionTemp => {
            const _question = questionTemp.clone();
            _question.status =  'U';
            _question.addedOn = newHRTimestamp();
            _question.addedBy = getCurrentUserId();
            _question.importSource = targetImportSource;
            _question.importId = mergeId;

            _question.importId = replaceWith.id;
            store.dispatch(Actions.QuestionActions.saveQuestionQueue(_question));
        });

    store.getState().redFlagTypes
        .getMappingFor('importExportId', importExport.id)
        .filter(redFlagTypeTemp => redFlagTypeTemp.status !== 'D')
        .forEach(redFlagTypeTemp => {
            const _redFlagType = redFlagTypeTemp.clone();
            _redFlagType.status =  'U';
            _redFlagType.addedOn = newHRTimestamp();
            _redFlagType.addedBy = getCurrentUserId();
            _redFlagType.importSource = targetImportSource;
            _redFlagType.importId = mergeId;

            _redFlagType.importId = replaceWith.id;
            store.dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType));
        });

    store.getState().redFlags
        .getMappingFor('importExportId', importExport.id)
        .filter(redFlagTemp => redFlagTemp.status !== 'D')
        .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            _redFlag.status =  'U';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;

            _redFlag.importId = replaceWith.id;
            store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
        });

    store.getState().resources
        .getMappingFor('importExportId', importExport.id)
        .filter(resourceTemp => resourceTemp.status !== 'D')
        .forEach(resourceTemp => {
            const _resource = resourceTemp.clone();
            _resource.status =  'U';
            _resource.addedOn = newHRTimestamp();
            _resource.addedBy = getCurrentUserId();
            _resource.importSource = targetImportSource;
            _resource.importId = mergeId;

            _resource.importId = replaceWith.id;
            store.dispatch(Actions.ResourceActions.saveResourceQueue(_resource));
        });

    store.getState().referrals
        .getMappingFor('importExportId', importExport.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.importId = replaceWith.id;
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    store.getState().roles
        .getMappingFor('importExportId', importExport.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.addedBy = getCurrentUserId();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.importId = replaceWith.id;
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    store.getState().tasks
        .getMappingFor('importExportId', importExport.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.importId = replaceWith.id;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('importExportId', importExport.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.addedBy = getCurrentUserId();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.importId = replaceWith.id;
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    store.getState().timeOffs
        .getMappingFor('importExportId', importExport.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.importId = replaceWith.id;
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    store.getState().transactions
        .getMappingFor('importExportId', importExport.id)
        .filter(transactionTemp => transactionTemp.status !== 'D')
        .forEach(transactionTemp => {
            const _transaction = transactionTemp.clone();
            _transaction.status =  'U';
            _transaction.addedOn = newHRTimestamp();
            _transaction.addedBy = getCurrentUserId();
            _transaction.importSource = targetImportSource;
            _transaction.importId = mergeId;

            _transaction.importId = replaceWith.id;
            store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
        });

    store.getState().users
        .getMappingFor('importExportId', importExport.id)
        .filter(userTemp => userTemp.status !== 'D')
        .forEach(userTemp => {
            const _user = userTemp.clone();
            _user.status =  'U';
            _user.addedOn = newHRTimestamp();
            _user.addedBy = getCurrentUserId();
            _user.importSource = targetImportSource;
            _user.importId = mergeId;

            _user.importId = replaceWith.id;
            store.dispatch(Actions.UserActions.saveUserQueue(_user));
        });

    return importExport;
}

/*
 * Determine the impact of deleting this importExport from other entities
 *
 * @param {ImportExport} importExport
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactImportExport(importExport: ImportExport) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const accountingConnectionImportIdImpact = state.accountingConnections
          .getMappingFor('importExportId', importExport.id)
          .filter(accountingConnection => accountingConnection.status !== 'D');

    accountingConnectionImportIdImpact.forEach(() => impacts.push('accountingConnections'));

    const activityCategoryImportIdImpact = state.activityCategories
          .getMappingFor('importExportId', importExport.id)
          .filter(activityCategory => activityCategory.status !== 'D');

    activityCategoryImportIdImpact.forEach(() => impacts.push('activityCategories'));

    const activityTypeImportIdImpact = state.activityTypes
          .getMappingFor('importExportId', importExport.id)
          .filter(activityType => activityType.status !== 'D');

    activityTypeImportIdImpact.forEach(() => impacts.push('activityTypes'));

    const addressImportIdImpact = state.addresses
          .getMappingFor('importExportId', importExport.id)
          .filter(address => address.status !== 'D');

    addressImportIdImpact.forEach(() => impacts.push('addresses'));

    const answerImportIdImpact = state.answers
          .getMappingFor('importExportId', importExport.id)
          .filter(answer => answer.status !== 'D');

    answerImportIdImpact.forEach(() => impacts.push('answers'));

    const bankAccountImportIdImpact = state.bankAccounts
          .getMappingFor('importExportId', importExport.id)
          .filter(bankAccount => bankAccount.status !== 'D');

    bankAccountImportIdImpact.forEach(() => impacts.push('bankAccounts'));

    const blackoutImportIdImpact = state.blackouts
          .getMappingFor('importExportId', importExport.id)
          .filter(blackout => blackout.status !== 'D');

    blackoutImportIdImpact.forEach(() => impacts.push('blackouts'));

    const categoryImportIdImpact = state.categories
          .getMappingFor('importExportId', importExport.id)
          .filter(category => category.status !== 'D');

    categoryImportIdImpact.forEach(() => impacts.push('categories'));

    const campaignImportIdImpact = state.campaigns
          .getMappingFor('importExportId', importExport.id)
          .filter(campaign => campaign.status !== 'D');

    campaignImportIdImpact.forEach(() => impacts.push('campaigns'));

    const docketImportIdImpact = state.dockets
          .getMappingFor('importExportId', importExport.id)
          .filter(docket => docket.status !== 'D');

    docketImportIdImpact.forEach(() => impacts.push('dockets'));

    const matterImportIdImpact = state.matters
          .getMappingFor('importExportId', importExport.id)
          .filter(matter => matter.status !== 'D');

    matterImportIdImpact.forEach(() => impacts.push('matters'));

    const commentImportIdImpact = state.comments
          .getMappingFor('importExportId', importExport.id)
          .filter(comment => comment.status !== 'D');

    commentImportIdImpact.forEach(() => impacts.push('comments'));

    const caseTypeImportIdImpact = state.caseTypes
          .getMappingFor('importExportId', importExport.id)
          .filter(caseType => caseType.status !== 'D');

    caseTypeImportIdImpact.forEach(() => impacts.push('caseTypes'));

    const caseTypeStageImportIdImpact = state.caseTypeStages
          .getMappingFor('importExportId', importExport.id)
          .filter(caseTypeStage => caseTypeStage.status !== 'D');

    caseTypeStageImportIdImpact.forEach(() => impacts.push('caseTypeStages'));

    const deadlineImportIdImpact = state.deadlines
          .getMappingFor('importExportId', importExport.id)
          .filter(deadline => deadline.status !== 'D');

    deadlineImportIdImpact.forEach(() => impacts.push('deadlines'));

    const deadlineRuleImportIdImpact = state.deadlineRules
          .getMappingFor('importExportId', importExport.id)
          .filter(deadlineRule => deadlineRule.status !== 'D');

    deadlineRuleImportIdImpact.forEach(() => impacts.push('deadlineRules'));

    const conflictImportIdImpact = state.conflicts
          .getMappingFor('importExportId', importExport.id)
          .filter(conflict => conflict.status !== 'D');

    conflictImportIdImpact.forEach(() => impacts.push('conflicts'));

    const contactImportIdImpact = state.contacts
          .getMappingFor('importExportId', importExport.id)
          .filter(contact => contact.status !== 'D');

    contactImportIdImpact.forEach(() => impacts.push('contacts'));

    const courtImportIdImpact = state.courts
          .getMappingFor('importExportId', importExport.id)
          .filter(court => court.status !== 'D');

    courtImportIdImpact.forEach(() => impacts.push('courts'));

    const courtDeadlineRuleImportIdImpact = state.courtDeadlineRules
          .getMappingFor('importExportId', importExport.id)
          .filter(courtDeadlineRule => courtDeadlineRule.status !== 'D');

    courtDeadlineRuleImportIdImpact.forEach(() => impacts.push('courtDeadlineRules'));

    const discountImportIdImpact = state.discounts
          .getMappingFor('importExportId', importExport.id)
          .filter(discount => discount.status !== 'D');

    discountImportIdImpact.forEach(() => impacts.push('discounts'));

    const entityTimestampImportIdImpact = state.entityTimestamps
          .getMappingFor('importExportId', importExport.id)
          .filter(entityTimestamp => entityTimestamp.status !== 'D');

    entityTimestampImportIdImpact.forEach(() => impacts.push('entityTimestamps'));

    const documentImportIdImpact = state.documents
          .getMappingFor('importExportId', importExport.id)
          .filter(document => document.status !== 'D');

    documentImportIdImpact.forEach(() => impacts.push('documents'));

    const expenseImportIdImpact = state.expenses
          .getMappingFor('importExportId', importExport.id)
          .filter(expense => expense.status !== 'D');

    expenseImportIdImpact.forEach(() => impacts.push('expenses'));

    const eventImportIdImpact = state.events
          .getMappingFor('importExportId', importExport.id)
          .filter(event => event.status !== 'D');

    eventImportIdImpact.forEach(() => impacts.push('events'));

    const firmImportIdImpact = state.firms
          .getMappingFor('importExportId', importExport.id)
          .filter(firm => firm.status !== 'D');

    firmImportIdImpact.forEach(() => impacts.push('firms'));

    const flatFeeImportIdImpact = state.flatFees
          .getMappingFor('importExportId', importExport.id)
          .filter(flatFee => flatFee.status !== 'D');

    flatFeeImportIdImpact.forEach(() => impacts.push('flatFees'));

    const flatFeeMilestoneImportIdImpact = state.flatFeeMilestones
          .getMappingFor('importExportId', importExport.id)
          .filter(flatFeeMilestone => flatFeeMilestone.status !== 'D');

    flatFeeMilestoneImportIdImpact.forEach(() => impacts.push('flatFeeMilestones'));

    const groupImportIdImpact = state.groups
          .getMappingFor('importExportId', importExport.id)
          .filter(group => group.status !== 'D');

    groupImportIdImpact.forEach(() => impacts.push('groups'));

    const holidayCalendarImportIdImpact = state.holidayCalendars
          .getMappingFor('importExportId', importExport.id)
          .filter(holidayCalendar => holidayCalendar.status !== 'D');

    holidayCalendarImportIdImpact.forEach(() => impacts.push('holidayCalendars'));

    const identificationImportIdImpact = state.identifications
          .getMappingFor('importExportId', importExport.id)
          .filter(identification => identification.status !== 'D');

    identificationImportIdImpact.forEach(() => impacts.push('identifications'));

    const importExportImportIdImpact = state.importExports
          .getMappingFor('importExportId', importExport.id)
          .filter(importExport => importExport.status !== 'D');

    importExportImportIdImpact.forEach(() => impacts.push('importExports'));

    const importSourceImportIdImpact = state.importSources
          .getMappingFor('importExportId', importExport.id)
          .filter(importSource => importSource.status !== 'D');

    importSourceImportIdImpact.forEach(() => impacts.push('importSources'));

    const invoiceImportIdImpact = state.invoices
          .getMappingFor('importExportId', importExport.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceImportIdImpact.forEach(() => impacts.push('invoices'));

    const invoiceBatchImportIdImpact = state.invoiceBatches
          .getMappingFor('importExportId', importExport.id)
          .filter(invoiceBatch => invoiceBatch.status !== 'D');

    invoiceBatchImportIdImpact.forEach(() => impacts.push('invoiceBatches'));

    const invoiceBatchItemImportIdImpact = state.invoiceBatchItems
          .getMappingFor('importExportId', importExport.id)
          .filter(invoiceBatchItem => invoiceBatchItem.status !== 'D');

    invoiceBatchItemImportIdImpact.forEach(() => impacts.push('invoiceBatchItems'));

    const leadImportIdImpact = state.leads
          .getMappingFor('importExportId', importExport.id)
          .filter(lead => lead.status !== 'D');

    leadImportIdImpact.forEach(() => impacts.push('leads'));

    const lookupImportIdImpact = state.lookups
          .getMappingFor('importExportId', importExport.id)
          .filter(lookup => lookup.status !== 'D');

    lookupImportIdImpact.forEach(() => impacts.push('lookups'));

    const matterStageImportIdImpact = state.matterStages
          .getMappingFor('importExportId', importExport.id)
          .filter(matterStage => matterStage.status !== 'D');

    matterStageImportIdImpact.forEach(() => impacts.push('matterStages'));

    const milestoneImportIdImpact = state.milestones
          .getMappingFor('importExportId', importExport.id)
          .filter(milestone => milestone.status !== 'D');

    milestoneImportIdImpact.forEach(() => impacts.push('milestones'));

    const optionImportIdImpact = state.options
          .getMappingFor('importExportId', importExport.id)
          .filter(option => option.status !== 'D');

    optionImportIdImpact.forEach(() => impacts.push('options'));

    const participantImportIdImpact = state.participants
          .getMappingFor('importExportId', importExport.id)
          .filter(participant => participant.status !== 'D');

    participantImportIdImpact.forEach(() => impacts.push('participants'));

    const privilegeImportIdImpact = state.privileges
          .getMappingFor('importExportId', importExport.id)
          .filter(privilege => privilege.status !== 'D');

    privilegeImportIdImpact.forEach(() => impacts.push('privileges'));

    const questionImportIdImpact = state.questions
          .getMappingFor('importExportId', importExport.id)
          .filter(question => question.status !== 'D');

    questionImportIdImpact.forEach(() => impacts.push('questions'));

    const redFlagTypeImportIdImpact = state.redFlagTypes
          .getMappingFor('importExportId', importExport.id)
          .filter(redFlagType => redFlagType.status !== 'D');

    redFlagTypeImportIdImpact.forEach(() => impacts.push('redFlagTypes'));

    const redFlagImportIdImpact = state.redFlags
          .getMappingFor('importExportId', importExport.id)
          .filter(redFlag => redFlag.status !== 'D');

    redFlagImportIdImpact.forEach(() => impacts.push('redFlags'));

    const resourceImportIdImpact = state.resources
          .getMappingFor('importExportId', importExport.id)
          .filter(resource => resource.status !== 'D');

    resourceImportIdImpact.forEach(() => impacts.push('resources'));

    const referralImportIdImpact = state.referrals
          .getMappingFor('importExportId', importExport.id)
          .filter(referral => referral.status !== 'D');

    referralImportIdImpact.forEach(() => impacts.push('referrals'));

    const roleImportIdImpact = state.roles
          .getMappingFor('importExportId', importExport.id)
          .filter(role => role.status !== 'D');

    roleImportIdImpact.forEach(() => impacts.push('roles'));

    const taskImportIdImpact = state.tasks
          .getMappingFor('importExportId', importExport.id)
          .filter(task => task.status !== 'D');

    taskImportIdImpact.forEach(() => impacts.push('tasks'));

    const templateTaskImportIdImpact = state.templateTasks
          .getMappingFor('importExportId', importExport.id)
          .filter(templateTask => templateTask.status !== 'D');

    templateTaskImportIdImpact.forEach(() => impacts.push('templateTasks'));

    const timeOffImportIdImpact = state.timeOffs
          .getMappingFor('importExportId', importExport.id)
          .filter(timeOff => timeOff.status !== 'D');

    timeOffImportIdImpact.forEach(() => impacts.push('timeOffs'));

    const transactionImportIdImpact = state.transactions
          .getMappingFor('importExportId', importExport.id)
          .filter(transaction => transaction.status !== 'D');

    transactionImportIdImpact.forEach(() => impacts.push('transactions'));

    const userImportIdImpact = state.users
          .getMappingFor('importExportId', importExport.id)
          .filter(user => user.status !== 'D');

    userImportIdImpact.forEach(() => impacts.push('users'));

    return util.countDistinct(impacts);
}